import * as React from 'react';

import type { ToastProps } from '@/components/ui/toast/toast.component';
import { useToastStore } from '@/store/toast.store';

type ToasterToast = ToastProps & {
  id: string;
  variant: 'default' | 'error';
  title?: React.ReactNode;
  description?: React.ReactNode;
};

let count = 0;
const genId = () => {
  count = (count + 1) % Number.MAX_SAFE_INTEGER;
  return count.toString();
};

type Toast = Omit<ToasterToast, 'id'>;

const useToast = () => {
  const { toasts, addToast, dismissToast } = useToastStore((state) => ({
    toasts: state.toasts,
    addToast: state.addToast,
    dismissToast: state.dismissToast,
  }));

  function toast({ ...props }: Toast) {
    const id = genId();

    let description = props.description as string;

    if (description && description.length > 250) {
      description = description.slice(0, 250) + '...';
    }

    addToast({
      ...props,
      id,
      variant: props.variant,
      description,
      onOpenChange: (open) => {
        if (!open) dismissToast(id);
      },
    });
    return {
      id: id,
    };
  }

  return {
    toasts,
    toast,
  };
};

export { useToast };
